// extracted by mini-css-extract-plugin
export default {"doubleDateTimeDisplay":"DoubleDateTimeDisplay_doubleDateTimeDisplay__HhOLQ"};